export const calculateAge = (
    birthDate: Date | string,
    startDate: Date | string
): number => {

    const parsedBirthDate =
        typeof birthDate === "string"
            ? new Date(birthDate)
            : birthDate;

    const parsedStartDate =
        typeof startDate === "string"
            ? toStartOfDay(new Date(startDate))
            : toStartOfDay(startDate);

    

    let age = parsedStartDate.getFullYear() - parsedBirthDate.getFullYear();

    const hasHadBirthdayThisYear =
        parsedStartDate.getMonth() > parsedBirthDate.getMonth() ||
        (parsedStartDate.getMonth() === parsedBirthDate.getMonth() &&
            parsedStartDate.getDate() >= parsedBirthDate.getDate());

    if (!hasHadBirthdayThisYear) {
        age--;
    }

    return age;
};

    const toStartOfDay = (date: Date): Date => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }